<template>
    <div class="row">
        <div class="col-lg-3">
            <div class="row">
                <div class="col">
                    <label>Aktiv?</label><br>
                    <switches :disabled="status.type === 'success'" style="margin-top: 0.8rem;" theme="bootstrap" color="primary" type-bold="true"
                              v-model="form.isActive">

                    </switches>
                </div>
                <div class="col">
                    <label>Öffentlich</label><br>
                    <switches :disabled="status.type === 'success'" style="margin-top: 0.8rem;" theme="bootstrap" color="primary" type-bold="true"
                              v-model="form.isPublic">

                    </switches>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <base-input alternative=""
                                :disabled="status.type === 'success'"
                                required
                                label="Name"
                                placeholder="Name des Fragebogens"
                                input-classes="form-control-alternative"
                                v-model="form.name"
                    />
                    <label class="form-control-label">
                        Sozialkonzept
                    </label>
                    <select v-model="form.socialconcept"
                            class="mb-1 custom-select form-control">
                        <option :value="null">keine Angabe</option>
                        <option v-for="sc in socialconcepts" :key="sc.id" :value="sc['@id']">{{ sc.name }}</option>
                    </select>
                    <label class="form-control-label">
                        Spielerschutzmaßnahme bei Anlage
                    </label>
                    <select v-model="form.action"
                            class="mb-1 custom-select form-control">
                        <option :value="null">Keine Spielerschutzmaßnahme anlegen</option>
                        <option v-for="action in actions" :key="action.id" :value="action['@id']">{{ action.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="col-lg-8">
            <textarea class="form-control form-control-alternative"
                      rows="4"
                      :disabled="status.type === 'success'"
                      required
                      label="Beschreibung"
                      placeholder="Kurze Beschreibung des Fragebogens bzgl. Inhalt und Ziele"
                      v-model="form.description"></textarea>
        </div>
    </div>
</template>
<script>
    import Switches from "vue-switches";
    export default {
        name: 'Formform',
        components: {Switches},
        props: {
          status: {}
        },
        data() {
            return {
                form: {
                    name: '',
                    description: '',
                    action: null,
                    isActive: true,
                    isPublic: true,
                    socialconcept: null
                },
                socialconcepts: {},
                socialconceptsAreLoading: false
            }
        },
        created() {
            this.getSocialconcepts();
            if (!this.$store.getters['actions/isLoading']) this.$store.dispatch('actions/getActionCollection');

        },
        computed: {
            actions(){
                return (!this.$store.getters['actions/isLoading'] && !this.$store.getters['actions/isEmpty']) ? Array.from(this.$store.getters['actions/showActionCollectionByConcept'](this.form.socialconcept)) : [{id: 0, name: ''}];
            },
        },
        methods: {
            getSocialconcepts() {
                return new Promise(() => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    this.socialconceptsAreLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/socialconcepts?pagination=false`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.socialconcepts = response['hydra:member'];
                                this.socialconceptsAreLoading = false;
                            },
                            error => {
                                this.socialconceptsAreLoading = false;
                                this.status =  {type: 'danger', msg: error};
                            });
                });
            }
        }
    }
</script>
